export const Perks = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_293_24347)">
      <path
        d="M12.25 4.08333H10.4218C10.8261 3.71471 11.1465 3.26352 11.3613 2.76031C11.5761 2.2571 11.6802 1.71362 11.6667 1.16667H10.5C10.5 2.84725 9.35025 3.67908 8.078 3.96667C8.46001 3.28522 8.68931 2.52886 8.75 1.75C8.75 1.28587 8.56563 0.840752 8.23744 0.512563C7.90925 0.184374 7.46413 0 7 0C6.53587 0 6.09075 0.184374 5.76256 0.512563C5.43437 0.840752 5.25 1.28587 5.25 1.75C5.31069 2.52886 5.53999 3.28522 5.922 3.96667C4.64975 3.67908 3.5 2.84725 3.5 1.16667H2.33333C2.3198 1.71362 2.42394 2.2571 2.63871 2.76031C2.85348 3.26352 3.17386 3.71471 3.57817 4.08333H1.75C1.28587 4.08333 0.840752 4.26771 0.512563 4.5959C0.184374 4.92409 0 5.3692 0 5.83333L0 8.16667H1.16667V14H12.8333V8.16667H14V5.83333C14 5.3692 13.8156 4.92409 13.4874 4.5959C13.1592 4.26771 12.7141 4.08333 12.25 4.08333ZM7 1.16667C7.15471 1.16667 7.30308 1.22812 7.41248 1.33752C7.52187 1.44692 7.58333 1.59529 7.58333 1.75C7.51291 2.36998 7.31426 2.96853 7 3.50758C6.68574 2.96853 6.48708 2.36998 6.41667 1.75C6.41667 1.59529 6.47812 1.44692 6.58752 1.33752C6.69692 1.22812 6.84529 1.16667 7 1.16667ZM1.16667 5.83333C1.16667 5.67862 1.22812 5.53025 1.33752 5.42085C1.44692 5.31146 1.59529 5.25 1.75 5.25H6.41667V7H1.16667V5.83333ZM2.33333 8.16667H6.41667V12.8333H2.33333V8.16667ZM11.6667 12.8333H7.58333V8.16667H11.6667V12.8333ZM12.8333 7H7.58333V5.25H12.25C12.4047 5.25 12.5531 5.31146 12.6625 5.42085C12.7719 5.53025 12.8333 5.67862 12.8333 5.83333V7Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24347">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
